import { Component, computed, contentChild, input, ChangeDetectionStrategy } from '@angular/core';
import { FormField } from '@angular/forms/signals';

@Component({
  selector: 'app-fieldset',
  imports: [],
  templateUrl: './fieldset.component.html',
  
  styleUrl: './fieldset.component.css',
})
export class FieldsetComponent {
  public label = input<string>();
  public legendId = input<string>();
  public legendClass = input<string>();
  public fieldsetClass = input<string>();
  public errorId = input<string>();
  public errorTestId = input<string>();
  public ariaDescribedBy = input<string>();
  public dataTestId = input<string>();
  public showErrors = input(true);
  public customLegend = input(false);

  private formField = contentChild(FormField);

  private state = computed(() => this.formField()?.state());

  protected errors = computed(() => this.state()?.errors());

  protected touched = computed(() => this.state()?.touched());
}
